// imports
import LazyLoad from "vanilla-lazyload";

//lazy load options
const lazyLoadOptions = {};
const pageLazyLoad = new LazyLoad(lazyLoadOptions);

document.addEventListener('DOMContentLoaded', function() {
    console.log('Modal system loaded');
    const body = document.body;
    
    // Generic modal handler
    function createModalHandler(modalSelector, options = {}) {
        const modal = document.querySelector(modalSelector);
        if (!modal) return null;
        
        const modalContent = options.contentSelector ? modal.querySelector(options.contentSelector) : null;
        const modalOverlay = modal.querySelector('[data-modal-overlay]');
        const modalClose = modal.querySelector('[data-modal-close]');
        const clearContentOnClose = options.clearContentOnClose !== false; // default to true
        const bodyClass = options.bodyClass || 'open-modal'; // Specific body class for this modal
        
        function openModal(content = null) {
            // Populate modal with content if provided
            if (content && modalContent) {
                modalContent.innerHTML = content;
            }
            
            // Show modal
            modal.hidden = false;
            modal.setAttribute('aria-hidden', 'false');
            
            // Add modal-specific class to body
            body.classList.add(bodyClass);
            
            // Add animate class after 5ms
            setTimeout(() => {
                body.classList.add(`animate-${bodyClass}`);
            }, 5);
            
            // Lazy load images
            pageLazyLoad.update();
            
            // Focus trap - focus the close button
            if (modalClose) {
                modalClose.focus();
            }
        }
        
        function closeModal() {
            // Remove animate class first
            body.classList.remove(`animate-${bodyClass}`);
            
            // After transition, remove open class and hide modal
            setTimeout(() => {
                body.classList.remove(bodyClass);
                modal.hidden = true;
                modal.setAttribute('aria-hidden', 'true');
                
                // Only clear content if specified
                if (clearContentOnClose && modalContent) {
                    modalContent.innerHTML = '';
                }
            }, 300); // Adjust timing to match your CSS transition duration
        }
        
        // Close on background click
        if (modalOverlay) {
            modalOverlay.addEventListener('click', closeModal);
        }
        
        // Close on close button click
        if (modalClose) {
            modalClose.addEventListener('click', closeModal);
        }
        
        // Close on Escape key - only for this specific modal
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && !modal.hidden) {
                closeModal();
            }
        });
        
        return { openModal, closeModal };
    }
    
    // Initialize Resource Modal
    const resourceModal = createModalHandler('[data-resource-modal]', {
        contentSelector: '[data-modal-content]',
        clearContentOnClose: true,
        bodyClass: 'open-resource-modal'
    });
    
    // Initialize Search Modal
    const searchModal = createModalHandler('[data-search-modal]', {
        contentSelector: '[data-modal-content]',
        clearContentOnClose: false,
        bodyClass: 'open-search-modal'
    });
    
    // Initialize Mailing List Modal
    const mailingListModal = createModalHandler('[data-mailing-list-modal]', {
        contentSelector: '[data-modal-content]',
        clearContentOnClose: false,
        bodyClass: 'open-mailing-list-modal'
    });
    
    // Listen for resource modal triggers
    if (resourceModal) {
        document.addEventListener('click', function(e) {
            const trigger = e.target.closest('[data-resource-modal-trigger]');
            
            if (trigger) {
                e.preventDefault();
                const resourceId = trigger.getAttribute('data-resource-id');
                const template = document.querySelector(`[data-resource-modal-template="${resourceId}"]`);
                
                if (template) {
                    const content = template.innerHTML;
                    resourceModal.openModal(content);
                }
            }
        });
    }
    
    // Listen for search modal triggers
    if (searchModal) {
        document.addEventListener('click', function(e) {
            const trigger = e.target.closest('.launch-search');
            
            if (trigger) {
                e.preventDefault();
                searchModal.openModal();
            }
        });
    }
    
    // Listen for mailing list modal triggers
    if (mailingListModal) {
        document.addEventListener('click', function(e) {
            const trigger = e.target.closest('.launch-mailing-list-modal');
            
            if (trigger) {
                e.preventDefault();
                mailingListModal.openModal();
            }
        });
    }
});